import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import agricultorReducer from '../services/agricultor/Reducer';
import apiReducer from '../services/api/Reducer';
import cidadeReducer from '../services/cidade/Reducer';
import codeReducer from '../services/code/Reducer';
import logradouroReducer from '../services/logradouro/Reducer';
import motoristaReducer from '../services/motorista/Reducer';
import pesagemReducer from '../services/pesagem/Reducer';
import messageResponseReducer from '../services/responses/Reducer';
import transportadoraReducer from '../services/transportadora/Reducer';
import veiculoReducer from '../services/veiculo/Reducer';
import vinculoTransporteReducer from '../services/vinculo_transporte/Reducer';
import fazendaReducer from '../services/fazenda/Reducer';
import produtoReducer from '../services/produto/Reducer';
import tipoServicoReducer from '../services/tipo_servico/Reducer';
import tipoPagamentoReducer from '../services/tipo_pagamento/Reducer';
import balancaReducer from '../services/balanca/Reducer';
import loginReducer from '../services/login/Reducer';

export default combineReducers({
    agricultorReducer,
    motoristaReducer,
    pesagemReducer,
    logradouroReducer,
    cidadeReducer,
    codeReducer,
    transportadoraReducer,
    veiculoReducer,
    vinculoTransporteReducer,
    fazendaReducer,
    produtoReducer,
    tipoServicoReducer,
    tipoPagamentoReducer,
    balancaReducer,
    loginReducer,
    messageResponseReducer: messageResponseReducer,
    apiReducer,
    form: formReducer
});


